import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { XIcon, ShoppingBagIcon } from 'lucide-react';
import { recentBuyers } from '../data/content';
import { images } from '../data/links';
const FIRST_DELAY = 6000;
const INTERVAL = 15000;
const VISIBLE_FOR = 5500;
export function PurchasePopup() {
  const [count, setCount] = useState(0);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    let hideTimer: number | undefined;
    const show = () => {
      setCount(c => c + 1);
      setOpen(true);
      hideTimer = window.setTimeout(() => setOpen(false), VISIBLE_FOR);
    };
    let interval: number | undefined;
    const first = window.setTimeout(() => {
      show();
      interval = window.setInterval(show, INTERVAL);
    }, FIRST_DELAY);
    return () => {
      window.clearTimeout(first);
      window.clearTimeout(hideTimer);
      window.clearInterval(interval);
    };
  }, []);
  const buyer = recentBuyers[(count - 1 + recentBuyers.length) % recentBuyers.length];
  return <div className="pointer-events-none fixed bottom-[92px] left-3 right-3 z-50 sm:right-auto sm:w-[360px] md:bottom-24" aria-live="polite" data-id="element-298" data-mp="163wesxfasa4y">
      <AnimatePresence data-id="element-299" data-mp="1fwbvlreuyso9">
        {open && <motion.div key={count} initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 8,
        scale: 0.96
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative flex items-center gap-3 rounded-2xl bg-white p-3 pr-9 shadow-[0_16px_40px_-12px_rgba(6,18,31,0.45)] ring-1 ring-slate-200" role="status" data-id="element-300" data-mp="1fv0sltt8loy7">
            <img src={images.mockup} alt="" className="h-14 w-14 shrink-0 rounded-xl bg-paper object-contain p-1" data-id="element-301" data-mp="s4n0y4ekds45" />
            <div className="min-w-0" data-id="element-302" data-mp="28mkghr0s3r6j">
              <p className="text-sm leading-snug text-ink" data-id="element-303" data-mp="23lwi2ka8082a">
                <span className="font-bold" data-id="element-304" data-mp="23nhao4cz5gxi">{buyer.name}</span> from <span className="font-bold" data-id="element-305" data-mp="2apctl5hq1bkk">{buyer.country}</span>
              </p>
              <p className="flex items-center gap-1 text-sm font-semibold text-cta" data-id="element-306" data-mp="2fn4swkkp3zys">
                <ShoppingBagIcon className="h-3.5 w-3.5 shrink-0" aria-hidden="true" data-id="element-307" data-mp="2kn0mdpvro903" />
                just purchased TRT Blueprint™
              </p>
              <p className="text-xs text-slate-400" data-id="element-308" data-mp="2plbvtzi5ghhs">{buyer.minutes} min ago</p>
            </div>
            <button type="button" onClick={() => setOpen(false)} className="absolute right-2 top-2 rounded-full p-1 text-slate-400 hover:bg-slate-100 hover:text-slate-600" aria-label="Close notification" data-id="element-309" data-mp="1rzen2ttknqj1">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-310" data-mp="26n7y017pq4va" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}